import _ from 'underscore';

export const selectRoot = (state) => state.favorites || {};

export const selectIsFavorite = (data) => (state) => {
	const { favorites } = selectRoot(state);

	return _(favorites).some(data);
};
